import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild,
  ElementRef,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getSegmentOptions } from 'src/app/shared/helpers/Drop-down-options';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { ColumnFilterPopupComponent } from './column-filter-popup/column-filter-popup.component';
import { DownloadPopupComponent } from './download-popup/download-popup.component';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import {
  pickFilterOptions,
} from 'src/app/shared/helpers/sc-looker-filter-options.util';
import { ScLookerFilterCascadeService } from 'src/app/shared/services/sc-looker-filter-cascade.service';

@Component({
  selector: 'app-databasetab',
  templateUrl: './databasetab.component.html',
  styleUrls: ['./databasetab.component.scss'],
})
export class DatabasetabComponent implements OnInit, OnDestroy {
  filterForm!: FormGroup;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  isLoadingTable: boolean = false;
  isLoadingStats: boolean = false;
  isLoadingSegments: boolean = false;
  isLoadingVessels: boolean = false;
  isLoadingLadenChart: boolean = false;
  isLoadingBallastChart: boolean = false;
  isLoadingBothChart: boolean = false;
  allVessels: any[] = []; // Global list for suggestions
  elements: any;
  chartData: any[] = []; // Lean chart-only data — 7 columns, all rows, single API call
  paginatedData: any[] = [];
  currentPage: number = 0;
  itemsPerPage: number = 25;
  pageSizeOptions: number[] = [25, 50, 100];
  totalRecords: number = 0;
  showFilteredCount: boolean = false;
  filteredCountValue: number = 0;
  isLoadingFilterOptions = false;
  isLoadingVesselOptions = false;
  conditionOptions: string[] = ['ALL'];
  statusOptions: string[] = ['ALL'];
  clientStatusOptions: string[] = [];
  apiClientOptions: string[] = [];
  segmentOptions: any[] = ['ALL'];
  typeofSpeedOptions: string[] = ['ALL'];
  technicalOperatorOptions: string[] = ['ALL'];
  commercialOperatorOptions: string[] = ['ALL'];
  vesselNameOptions: string[] = [];
  private filterOptionsRequestSeq = 0;
  private readonly cascadeOrder = [
    'clientStatus',
    'client',
    'type_of_ship',
    'segment',
    'vessel',
    'condition',
    'vesselStatus',
    'type_speed',
    'technical_operator',
    'commercial_operator',
  ] as const;
  private suppressFilterCascade = false;
  private readonly downstreamFormFields = [
    'segment',
    'condition',
    'type_of_ship',
    'vesselStatus',
    'type_speed',
    'technical_operator',
    'commercial_operator',
  ] as const;
  segmentMapping: { [key: string]: any[] } = {
    'Bulk carrier': [
      'Coaster',
      'Handysize',
      'Handymax',
      'Supramax',
      'Ultramax',
      'Panamax',
      'Kamsarmax',
      'Ultrapanamax',
      'Capesize',
      'VLOC',
      'Chinamax',
    ],
    Tanker: [
      'Coastal',
      'Intermediate',
      'Handytankers',
      'MR2',
      'LR1/Panamax',
      'LR2/Aframax',
      'LR3/Suezmax',
      'VLCC',
    ],
    'Gas Tanker': ['Coasters', 'Handysize', 'MGC', 'LGC', 'VLGC', 'VLEC'],
    'Container ship': [],
    'General cargo': [
      'Coaster',
      'Handysize',
      'Handymax',
      'Supramax',
      'Ultramax',
      'Panamax',
      'Kamsarmax',
      'Ultrapanamax',
      'Capesize',
      'VLOC',
      'Chinamax',
    ],
    'Passenger ship': [],
  };
  isFilterOpen = false;
  totalVessels: any;
  activeVessels: any;
  inactiveVessels: any;
  underPerformanceFuel: any;
  underPerformanceTime: any;
  private latestStats: any = null;
  csvHeader: any;
  DatabaseData: any;
  graph: boolean = false;
  barChart!: Chart;
  segments: any = [];
  selectedSegment: string = 'Aframax';
  ladenChart: any;
  ballastChart: any;
  bothChart: any;
  ladenSelectedSegment: any;
  ballastSelectedTypeOfShip: any;
  ladenSelectedTypeOfShip: any;
  ballastSelectedSegment: any;
  bothSelectedSegment: any;
  dropdownOpen = false; // Track dropdown visibility
  selectedShips: string[] = []; // Array to store selected ship names
  shipNameSuggestions: any[] = [];
  // Dynamic segments for each graph
  ladenSegments: string[] = [];

  ballastTypeOfShip: string[] = [
    'Bulk carrier',
    'Container ship',
    'General cargo',
    'Passenger ship',
    'Tanker',
    'Gas Tanker',
  ];
  ladenTypeOfShip: string[] = [
    'Bulk carrier',
    'Container ship',
    'General cargo',
    'Passenger ship',
    'Tanker',
    'Gas Tanker',
  ];
  ballastSegments: string[] = [];
  bothSegments: string[] = [];
  underPerformanceFuelVessels: any;
  underPerformanceTimeVessels: any;
  fuelTooltipContent: any;
  timeTooltipContent: any;
  username: any;
  form: any;
  ladenData: any;
  ballastData: any;
  bothData: any;
  sortMapData: boolean = false;
  isSorting: boolean = false;
  isAscending: boolean = false;
  azsort: boolean = false;
  columns = [
    { key: 'sNo', label: 'S.No', visible: true, sortable: false },
    { key: 'vessel_name', label: 'Ship Name', visible: true, fixed: true },
    { key: 'imo', label: 'I.M.O Number', visible: true },
    { key: 'year_built', label: 'Year Built', visible: true },
    { key: 'type_of_ship', label: 'Type Of Ship', visible: true },
    { key: 'segment', label: 'Segment', visible: true },
    { key: 'pic', label: 'Meraki PIC', visible: true },
    { key: 'type_speed', label: 'Type of Speed', visible: true },
    { key: 'technical_operator', label: 'Technical Operator', visible: true },
    { key: 'commercial_operator', label: 'Commercial Operator', visible: true },
    { key: 'start_port', label: 'Start Port', visible: true },
    { key: 'start_date', label: 'Start Time (UTC)', visible: true },
    { key: 'end_port', label: 'End Port', visible: true },
    { key: 'end_date', label: 'End Time (UTC)', visible: true },
    { key: 'voyage_type', label: 'Condition', visible: true },
    { key: 'pdf_created', label: 'Generated Date (UTC)', visible: true },
    { key: 'cp_speed', label: 'CP Speed(Kts)', visible: true },
    { key: 'cp_consumption', label: 'CP Consumption(mts)', visible: true },
    { key: 'daysAtSea', label: 'Days At Sea', visible: true },
    { key: 'totalFuelLg', label: 'Total Fuel L/G(mts)', visible: true },
    { key: 'totalTimeLg', label: 'Total Time L/G(hrs)', visible: true },
    { key: 'total_distance', label: 'Total Dist(nm)', visible: true },
    { key: 'total_time', label: 'Total Time(hrs)', visible: true },
    {
      key: 'total_bunkers_consumed_at_sea',
      label: 'Total Bunker Cons(mts)',
      visible: true,
    },
    { key: 'avg_speed', label: 'Average Speed (Kts)', visible: true },
    {
      key: 'total_avg_daily_cons',
      label: 'Total Avg Daily Cons(mts)',
      visible: true,
    },
    { key: 'gw_distance', label: 'GW Distance(nm)', visible: true },
    { key: 'gw_time', label: 'GW Time(hrs)', visible: true },
    { key: 'GW_Pcx', label: 'GW Pct(%)', visible: true },
    { key: 'avg_speed_in_gw', label: 'GW Avg Speed(Kts)', visible: true },
    { key: 'GW_cons', label: 'GW Consumption(mts)', visible: true },
    { key: 'gwAvgDailyCons', label: 'GW Avg Daily Cons(mts)', visible: true },
    {
      key: 'adverse_weather_distance',
      label: 'Adverse Wx Dist(nm)',
      visible: true,
    },
    {
      key: 'adverse_weather_time',
      label: 'Adverse Wx Time(hrs)',
      visible: true,
    },
    {
      key: 'avg_speed_in_adverse_wx',
      label: 'Avg Speed in Adverse Wx',
      visible: true,
    },
    {
      key: 'avg_cons_in_adverser_wx',
      label: 'Avg Cons in Adverse Wx',
      visible: true,
    },
  ];
  totalVoyages: any;
  nav: any;
  private destroy$ = new Subject<void>();
  apiLadenSegments: any;
  apiBallastSegments: any;
  clientSuggestions: string[] = [];
  allClients: string[] = []; // populate from API
  selectedClients: string[] = [];
  typeofshipOptions: string[] = ['ALL'];
  filteredData: any;
  clientDropdownOpen = false;
  selectedClientLabel = '';
  expandGwMetrics = false;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private scLookerFilterCascade: ScLookerFilterCascadeService,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.nav = params['source'] === 'fleet-performance';
      if (this.nav) {
        this.graph = true;
      }
    });

    this.filterForm = this.fb.group({
      clientStatus: [null],
      from_date: ['', [Validators.required]],
      to_date: ['', [Validators.required]],
      reportfrom_date: ['', [Validators.required]],
      reportto_date: ['', [Validators.required]],
      condition: ['ALL'],
      imo:[''],
      vesselName: [''],
      vesselStatus: ['ALL'],
      client: [''],
      segment: ['ALL'],
      type_of_ship: ['ALL'],
      type_speed: ['ALL'],
      technical_operator: ['ALL'],
      commercial_operator: ['ALL'],
    });
  }
  ngOnInit() {
    if (localStorage.getItem('mapToggle') === 'true') {
      this.graph = true;
    }
    this.username = localStorage.getItem('username');
    this.setupFilterCascade();
    this.loadFilterOptions();
    if (this.username !== 'Eiger Shipping') {
      this.loadStats();
      // this.loadStatSegments();
      this.loadAllDataPaginated();
    }
  }

  private setupFilterCascade(): void {
    this.filterForm
      .get('clientStatus')
      ?.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.suppressFilterCascade) {
          return;
        }
        this.onClientStatusChanged();
      });

    this.downstreamFormFields.forEach((field) => {
      this.filterForm
        .get(field)
        ?.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
        .subscribe(() => {
          if (this.suppressFilterCascade) {
            return;
          }
          this.onDownstreamFilterChanged(field);
        });
    });
  }

  isClientFilterEnabled(): boolean {
    return true;
  }

  hasClientSelected(): boolean {
    return this.selectedClients.length > 0;
  }

  areDownstreamFiltersEnabled(): boolean {
    return this.isClientFilterEnabled() && this.hasClientSelected();
  }

  isClientFieldBlocked(): boolean {
    return !this.isClientFilterEnabled();
  }

  isDownstreamFieldBlocked(): boolean {
    return !this.areDownstreamFiltersEnabled();
  }

  onClientsChanged(clients: string[]): void {
    this.selectedClients = clients || [];
    this.updateClientLabel();
    if (this.suppressFilterCascade) {
      return;
    }
    this.clearDownstreamFrom('client');
    if (this.hasClientSelected()) {
      this.loadFilterOptions();
    }
  }

  onVesselsChanged(vessels: string[]): void {
    this.selectedShips = vessels || [];
    this.updateShipLabel();
    if (this.suppressFilterCascade) {
      return;
    }
    this.clearDownstreamFrom('vessel');
    this.loadFilterOptions();
  }

  private onClientStatusChanged(): void {
    this.clearDownstreamFrom('clientStatus');
    this.loadFilterOptions();
  }

  private onDownstreamFilterChanged(field: string): void {
    const cascadeField = field === 'condition' ? 'condition' : field;
    const idx = this.cascadeOrder.indexOf(cascadeField as any);
    if (idx < 0) {
      return;
    }
    this.clearDownstreamFrom(this.cascadeOrder[idx]);
    this.loadFilterOptions();
   
      this.refreshVesselNameOptions();
    
  }

  private clearDownstreamFrom(level: string): void {
    this.suppressFilterCascade = true;
    const idx = this.cascadeOrder.indexOf(level as any);
    if (idx < 0) {
      this.suppressFilterCascade = false;
      return;
    }

    const clientStatusIdx = this.cascadeOrder.indexOf('clientStatus');
    const clientIdx = this.cascadeOrder.indexOf('client');
    const segmentIdx = this.cascadeOrder.indexOf('segment');

    if (idx <= clientStatusIdx) {
      this.selectedClients = [];
      this.updateClientLabel();
    }

    if (idx <= clientIdx) {
      this.selectedShips = [];
      this.updateShipLabel();
      this.vesselNameOptions = [];
      this.apiClientOptions = [];
    } else if (idx <= segmentIdx) {
      this.selectedShips = [];
      this.updateShipLabel();
      this.vesselNameOptions = [];
    }

    const fieldMap: Record<string, string> = {
      segment: 'segment',
      condition: 'condition',
      type_of_ship: 'type_of_ship',
      vesselStatus: 'vesselStatus',
      type_speed: 'type_speed',
      technical_operator: 'technical_operator',
      commercial_operator: 'commercial_operator',
    };

    for (let i = idx + 1; i < this.cascadeOrder.length; i++) {
      const key = this.cascadeOrder[i];
      if (key === 'client' || key === 'vessel') {
        continue;
      }
      const formKey = fieldMap[key];
      if (formKey) {
        this.filterForm.get(formKey)?.setValue('ALL', { emitEvent: false });
      }
    }

    this.suppressFilterCascade = false;
  }

  private resetDownstreamOptionLists(): void {
    this.segmentOptions = ['ALL'];
    this.statusOptions = ['ALL'];
    this.conditionOptions = ['ALL'];
    this.typeofshipOptions = ['ALL'];
    this.typeofSpeedOptions = ['ALL'];
    this.technicalOperatorOptions = ['ALL'];
    this.commercialOperatorOptions = ['ALL'];
  }

  loadFilterOptions(): void {
    const requestSeq = ++this.filterOptionsRequestSeq;
    const raw = this.filterForm.getRawValue();

    this.isLoadingFilterOptions = true;
    this.scLookerFilterCascade
      .fetchFilterOptions(
        this.username,
        {
          clientStatus: raw.clientStatus,
          segment: raw.segment,
          vesselStatus: raw.vesselStatus,
          condition: raw.condition,
          typeOfShip: raw.type_of_ship,
          typeSpeed: raw.type_speed,
          technicalOperator: raw.technical_operator,
          commercialOperator: raw.commercial_operator,
        },
        this.selectedClients,
        this.selectedShips,
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (options) => {
          if (requestSeq !== this.filterOptionsRequestSeq) {
            return;
          }
          this.applyFilterOptionsFromResponse(options);
          this.isLoadingFilterOptions = false;
          if (this.hasClientSelected() && !this.vesselNameOptions.length) {
            this.refreshVesselNameOptions();
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          if (requestSeq !== this.filterOptionsRequestSeq) {
            return;
          }
          console.error('Failed to load filter options', err);
          this.isLoadingFilterOptions = false;
          this.cdr.detectChanges();
        },
      });
  }

  private applyFilterOptionsFromResponse(
    options: ReturnType<typeof pickFilterOptions>,
  ): void {
    if (options.clientStatusOptions.length) {
      this.clientStatusOptions = options.clientStatusOptions;
    }

    if ( options.clientOptions.length) {
      this.apiClientOptions = options.clientOptions;
    }

    // if (!this.hasClientSelected()) {
    //   return;
    // }

   const segmentLabelMap: { [key: string]: string } = {
  'MR': 'MR2',
  'MR2': 'MR2',

  'PANAMAX': 'LR1 / Panamax',
  'LR1/PANAMAX': 'LR1 / Panamax',

  'AFRAMAX': 'LR2 / Aframax',
  'LR2/AFRAMAX': 'LR2 / Aframax',

  'SUEZMAX': 'LR3 / Suezmax',
  'LR3/SUEZMAX': 'LR3 / Suezmax',

  'INTERMEDIATE': 'Intermediate / Coastal',
  'COASTAL': 'Intermediate / Coastal',

  'HANDYTANKERS': 'Handy(6W)',

  'VLCC': 'VLCC'
};

if (options.vesselNameOptions?.length) {
    this.vesselNameOptions = this.mergeVesselNameOptions(
      options.vesselNameOptions.map((name: string) => name.toUpperCase())
    );
  }

this.bindOptionList('segmentOptions', options.segmentOptions, (values: string[]) => {
  this.segmentOptions = [
    ...new Set(
      values.map(value => segmentLabelMap[value.toUpperCase()] || value)
    )
  ];
});
    this.bindOptionList(
      'conditionOptions',
      options.voyageTypeOptions,
      (values) => {
        this.conditionOptions = values;
      },
    );
    this.bindOptionList(
      'typeofshipOptions',
      options.typeOfShipOptions,
      (values) => {
        this.typeofshipOptions = values;
      },
    );
    this.bindOptionList(
      'statusOptions',
      options.vesselStatusOptions,
      (values) => {
        this.statusOptions = values;
      },
    );
    this.bindOptionList(
      'typeofSpeedOptions',
      options.speedTypeOptions,
      (values) => {
        this.typeofSpeedOptions = values;
      },
    );
    this.bindOptionList(
      'vesselNameOptions',
      options.vesselNameOptions,
      (values) => {
        this.vesselNameOptions = this.mergeVesselNameOptions(
      values.map((name: string) => name.toUpperCase())
    );;
      },
    );
    this.bindOptionList(
      'technicalOperatorOptions',
      options.technicalOperatorOptions,
      (values) => {
        this.technicalOperatorOptions = values;
      },
    );
    this.bindOptionList(
      'commercialOperatorOptions',
      options.commercialOperatorOptions,
      (values) => {
        this.commercialOperatorOptions = values;
      },
    );

    // if (options.vesselNameOptions.length) {
    //   this.vesselNameOptions = this.mergeVesselNameOptions(
    //     options.vesselNameOptions,
    //   );
    // }

    this.pruneInvalidFilterSelections();
  }

  private bindOptionList(
    _key: string,
    values: string[],
    assign: (values: string[]) => void,
  ): void {
    if (values?.length) {
      assign(values);
    }
  }

  private mergeVesselNameOptions(apiNames: string[]): string[] {
  const merged = new Set<string>();
  
  (apiNames || []).forEach((name) => {
    const normalized = String(name).trim().toUpperCase();
    if (normalized) {
      merged.add(normalized);
    }
  });

  (this.selectedShips || []).forEach((name) => {
    const normalized = String(name).trim().toUpperCase();
    if (normalized) {
      merged.add(normalized);
    }
  });

  return Array.from(merged).sort((a, b) => a.localeCompare(b));
}

  private pruneInvalidFilterSelections(): void {
    this.suppressFilterCascade = true;

    this.selectedClients = this.selectedClients.filter((client) =>
      this.apiClientOptions.includes(client),
    );
    this.updateClientLabel();

    this.pruneFormControlToOptions('segment', this.segmentOptions);
    this.pruneFormControlToOptions('condition', this.conditionOptions);
    this.pruneFormControlToOptions('type_of_ship', this.typeofshipOptions);
    this.pruneFormControlToOptions('vesselStatus', this.statusOptions);
    this.pruneFormControlToOptions('type_speed', this.typeofSpeedOptions);
    this.pruneFormControlToOptions(
      'technical_operator',
      this.technicalOperatorOptions,
    );
    this.pruneFormControlToOptions(
      'commercial_operator',
      this.commercialOperatorOptions,
    );

    if (this.vesselNameOptions.length) {
      this.selectedShips = this.selectedShips.filter((name) =>
        this.vesselNameOptions.includes(name),
      );
      this.updateShipLabel();
    }

    this.suppressFilterCascade = false;
  }

  private pruneFormControlToOptions(
    controlName: string,
    options: string[],
  ): void {
    const control = this.filterForm.get(controlName);
    const value = control?.value;
    if (
      value &&
      value !== 'ALL' &&
      options.length &&
      !options.includes(value)
    ) {
      control?.setValue('ALL', { emitEvent: false });
    }
  }

  private updateShipLabel(): void {
    this.selectedShipLabel =
      this.selectedShips.length === 0
        ? 'Select a ship'
        : this.selectedShips.length === 1
          ? this.selectedShips[0]
          : `${this.selectedShips.length} selected`;
  }

  private refreshVesselNameOptions(): void {
  const applyVesselNames = (vessels: any[]) => {
    const raw = this.filterForm.getRawValue();
    const segment = raw.segment?.trim().toLowerCase();
    const clientFilter = this.getClientFilter(this.selectedClients);
    const uniqueNames = new Set<string>();

    (vessels || []).forEach((item: any) => {
      const vesselName = (item.vessel_name || '').trim();
      if (!vesselName) {
        return;
      }
      if (!clientFilter(item)) {
        return;
      }
      const itemSegment = (item.segment || '').trim().toLowerCase();
      if (
        segment &&
        segment !== 'all' &&
        itemSegment &&
        itemSegment !== segment
      ) {
        return;
      }
      uniqueNames.add(vesselName.toUpperCase());
    });

    this.vesselNameOptions = this.mergeVesselNameOptions(
      Array.from(uniqueNames)
    );
    this.selectedShips = this.selectedShips.filter((name) =>
      this.vesselNameOptions.includes(name)
    );
    this.updateShipLabel();
    this.isLoadingVesselOptions = false;
    this.cdr.detectChanges();
  };

  if (this.allVessels.length) {
    applyVesselNames(this.allVessels);
    return;
  }

  this.isLoadingVesselOptions = true;
  this.sharedDataService
    .getLookerVessels(this.username)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (res: any) => {
        this.allVessels = res || [];
        applyVesselNames(this.allVessels);
      },
      error: (err) => {
        console.error('Failed to load vessel names', err);
        this.isLoadingVesselOptions = false;
        this.cdr.detectChanges();
      },
    });
}

  private buildTableFilters(): any {
    const raw = this.filterForm.getRawValue();
    const conditionValue = raw.condition;
    const statusValue = raw.vesselStatus;
    const clientStatusValue = raw.clientStatus;
    const segmentValue = raw.segment;
    const typeOfShipValue = raw.type_of_ship;
    const typeOfSpeed = raw.type_speed;
    const technicalSpeedValue = raw.technical_operator;
    const commercialSpeedValue = raw.commercial_operator;
    const imoValue = raw.imo;

    return {
      from_date: this.convertDate(raw.from_date),
      to_date: this.convertDate(raw.to_date),
      report_from: this.convertDate(raw.reportfrom_date),
      report_to: this.convertDate(raw.reportto_date),
      client_status:
        clientStatusValue && clientStatusValue !== 'ALL'
          ? clientStatusValue
          : '',
      voyage_type:
        conditionValue && conditionValue !== 'ALL' ? conditionValue : '',
      vessel_status: statusValue && statusValue !== 'ALL' ? statusValue : '',
      type_of_ship:
        typeOfShipValue && typeOfShipValue !== 'ALL' ? typeOfShipValue : '',
      client: this.selectedClients?.length ? this.selectedClients : [],
      segment: segmentValue && segmentValue !== 'ALL' ? segmentValue : '',
      vessel_names: this.selectedShips?.length ? this.selectedShips : [],
      type_speed: typeOfSpeed && typeOfSpeed !== 'ALL' ? typeOfSpeed : '',
      technical_operator:
        technicalSpeedValue && technicalSpeedValue !== 'ALL'
          ? technicalSpeedValue
          : '',
      commercial_operator:
        commercialSpeedValue && commercialSpeedValue !== 'ALL'
          ? commercialSpeedValue
          : '',
       imo: imoValue ? imoValue : '',
    };
  }

  toggleGwMetrics(event?: Event) {
    event?.stopPropagation();
    this.expandGwMetrics = !this.expandGwMetrics;
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  // ─── Legacy: fetched all 22k rows at once ─────────────────────────────
  // loadData() {
  //   this.sharedDataService.getDatabase().subscribe((data) => {
  //     if (!Array.isArray(data)) { data = Object.values(data); }
  //     const clientFilters: { [key: string]: (item: any) => boolean } = {
  //       'Eiger Shipping': (item) => item.client_name === 'Northwell' || item.client_name === 'Eiger',
  //       'Zeronorth ZN': (item) => item.client_name === 'ZeroNorth',
  //       'Elite Shipping': (item) => item.client_name === 'Elite' || item.client_name === 'ELITE TANKSHIP DMCC',
  //       'Bunge Shipping': (item) => item.client_name === 'Bunge',
  //       'Alcor Shipping': (item) => item.client_name === 'ALCOR CHARTERING DMCC',
  //       'EMZoil Shipping': (item) => item.client_name === 'EMZ OIL',
  //       'Ethiopian Shipping & Logistics': (item) => item.client_name.toLowerCase() === 'ethiopian shipping & logistics',
  //     };
  //     if (this.username === 'Meraki - Operations') { data = data; }
  //     else if (clientFilters[this.username]) { data = data.filter(clientFilters[this.username]); }
  //     this.elements = data.map((item: any) => { ... });
  //     ...
  //   });
  // }
  // ───────────────────────────────────────────────────────────────

  /** Fetches aggregate counts (respecting optional filters) */
  loadStats(filters: any = null) {
    this.isLoadingStats = true;
    this.sharedDataService
      .getLookerStats(this.username, filters)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (stats: any) => {
          this.latestStats = stats;
          this.totalVoyages = stats.total_voyages;
          this.totalVessels = stats.total_vessels;
          this.activeVessels = stats.active_vessels;
          this.inactiveVessels = stats.inactive_vessels;
          this.underPerformanceFuel = stats.underperformance_fuel;
          this.underPerformanceTime = stats.underperformance_time;
          this.totalRecords = Number(stats.total_voyages || 0);
          this.updatePageSizeOptions(this.totalRecords);
          if (this.paginator) {
            this.paginator.length = this.totalRecords;
          }

          this.underPerformanceFuelVessels = stats.fuel_underperf_vessels ?? [];
          this.underPerformanceTimeVessels = stats.time_underperf_vessels ?? [];

          this.fuelTooltipContent = this.underPerformanceFuelVessels.join(', ');
          this.timeTooltipContent = this.underPerformanceTimeVessels.join(', ');
          this.isLoadingStats = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Failed to load stats', err);
          this.isLoadingStats = false;
          this.cdr.detectChanges();
        },
      });
  }

  private isGraceUser(): boolean {
    const subuser = (localStorage.getItem('loginPic') ?? localStorage.getItem('subusername') ?? '').trim().toLowerCase();
    const user = (localStorage.getItem('username') ?? '').trim().toLowerCase();
    return subuser === 'grace' || user === 'emzoil_grace' || user.includes('grace');
  }

  /** Fetches available segments/types once to populate dropdowns */
  loadStatSegments() {
    const clientNameMap: any = {
      meraki: 'Meraki - Operations',
      eiger: 'Eiger Shipping',
      zeronorth: 'Zeronorth ZN',
      elite: 'Elite Shipping',
      bunge: 'Bunge Shipping',
      alcor: 'Alcor Shipping',
      ethiopian: 'Ethiopian Shipping & Logistics',
      'emz oil': 'EMZoil Shipping',
      'emzoil fzco': 'EMZoil Shipping',
      'emzoil': 'EMZoil Shipping',
    };

    const selectedClient = this.selectedClients[0];

    const getMappedClientName = (client: string) => {
      if (!client) return this.username; // fallback (already correct)

      const normalized = client.toLowerCase();

      const key = Object.keys(clientNameMap).find((k) =>
        normalized.includes(k),
      );

      return key ? clientNameMap[key] : client;
    };

    const clientValue = getMappedClientName(selectedClient);
    this.isLoadingSegments = true;
    this.sharedDataService
      .getLookerSegments(clientValue)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.apiLadenSegments = data.laden || [];
          this.apiBallastSegments = data.ballast || [];
          if (this.isGraceUser()) {
            const isSuezmax = (s: string) => {
              const lower = (s || '').toLowerCase();
              return lower.includes('suezmax') || lower.includes('lr3');
            };
            this.apiLadenSegments = this.apiLadenSegments.filter(isSuezmax);
            if (!this.apiLadenSegments.length) this.apiLadenSegments = ['LR3/Suezmax'];
            this.apiBallastSegments = this.apiBallastSegments.filter(isSuezmax);
            if (!this.apiBallastSegments.length) this.apiBallastSegments = ['LR3/Suezmax'];
          }
          this.ladenSegments = this.isGraceUser() ? [...this.apiLadenSegments] : (data.laden || []);
          this.ballastSegments = this.isGraceUser() ? [...this.apiBallastSegments] : (data.ballast || []);
          this.bothSegments = Array.from(
            new Set([...this.ladenSegments, ...this.ballastSegments]),
          );
          this.ladenSelectedSegment = this.isGraceUser() ? 'LR3/Suezmax' : this.ladenSegments[0];
          this.ballastSelectedSegment = this.isGraceUser() ? 'LR3/Suezmax' : this.ballastSegments[0];
          this.bothSelectedSegment = this.isGraceUser() ? 'LR3/Suezmax' : this.bothSegments[0];
          this.loadSegments();
          this.isLoadingSegments = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Failed to load segments', err);
          this.isLoadingSegments = false;
          this.cdr.detectChanges();
        },
      });
  }

  /** On-demand fetch for ONE chart render in databasetab */
  fetchChartData(condition: string, segment: string) {
    if (this.isGraceUser()) {
      segment = 'LR3/Suezmax';
    }
    if (condition === 'Laden') this.isLoadingLadenChart = true;
    else if (condition === 'Ballast') this.isLoadingBallastChart = true;
    else if (condition === 'both') this.isLoadingBothChart = true;
    const clientNameMap: any = {
      meraki: 'Meraki - Operations',
      eiger: 'Eiger Shipping',
      zeronorth: 'Zeronorth ZN',
      elite: 'Elite Shipping',
      bunge: 'Bunge Shipping',
      alcor: 'Alcor Shipping',
      ethiopian: 'Ethiopian Shipping & Logistics',
      'emz oil': 'EMZoil Shipping',
      'emzoil fzco': 'EMZoil Shipping',
      'emzoil': 'EMZoil Shipping',
    };
    const selectedClient = this.selectedClients[0];

    const getMappedClientName = (client: string) => {
      if (!client) return this.username; // fallback (already correct)

      const normalized = client.toLowerCase();

      const key = Object.keys(clientNameMap).find((k) =>
        normalized.includes(k),
      );

      return key ? clientNameMap[key] : client;
    };

    const clientValue = getMappedClientName(selectedClient);
    this.sharedDataService
      .getLookerChartData(clientValue, segment)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any[]) => {
          let chartItems = data || [];
          if (this.isGraceUser()) {
            const graceImos = ['9378876', '9399480', '9438406', '9432048'];
            const graceNames = ['gregal', 'llevant', 'migjorn', 'vendavel'];
            chartItems = chartItems.filter((item: any) => {
              const imo = String(item?.vessel_id ?? item?.imo ?? item?.imo_number ?? '').trim();
              const name = (item?.vessel_name || '').trim().toLowerCase();
              const seg = (item?.segment || '').trim().toLowerCase();
              const isSuezmax = seg.includes('suezmax') || seg.includes('lr3');
              return (graceImos.includes(imo) || graceNames.includes(name)) && (isSuezmax || !seg);
            });
          }
          const normalized = chartItems.map((item) => ({
            ...item,
            voyage_type: item.voyage_type === 'True' ? 'Laden' : 'Ballast',
            segment: this.normalizeSegment(item.segment),
          }));

          const result = this.calculateAverages(normalized);
          const title = `${segment || ''} ${condition} Performance`;

          if (condition === 'Laden') {
            this.ladenChart = this.createChart(title, result);
            this.ladenData = result;
            this.isLoadingLadenChart = false;
          } else if (condition === 'Ballast') {
            this.ballastChart = this.createChart(title, result);
            this.ballastData = result;
            this.isLoadingBallastChart = false;
          } else if (condition === 'both') {
            this.bothChart = this.createChart(title, result);
            this.bothData = result;
            this.isLoadingBothChart = false;
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(
            `Failed to load chart data for ${condition} ${segment}`,
            err,
          );
          if (condition === 'Laden') this.isLoadingLadenChart = false;
          else if (condition === 'Ballast') this.isLoadingBallastChart = false;
          else if (condition === 'both') this.isLoadingBothChart = false;
          this.cdr.detectChanges();
        },
      });
  }
  loadingMessage: string = 'Loading data, please wait...';
  /** Legacy: no longer used */
  // loadChartData() { ... }
  /** Fetches only the requested page from /looker-studio-data (respects filters) */
  loadAllDataPaginated(page: number = 1, filters: any = null) {
    console.log('API FILTERS RECEIVED =>', filters);

    this.isLoadingTable = true;

    this.sharedDataService
      .getLookerData(this.username, page, filters)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const rawData: any[] = Object.values(response.data ?? {});

          // =========================
          // PROCESS DATA
          // =========================

          const processed = rawData.map((item: any) => {
            item.voyage_type =
              item.voyage_type === 'True' ? 'Laden' : 'Ballast';

            item.vessel_status =
              item.vessel_status === 'True' ? 'Active' : 'Inactive';

            item.daysAtSea = this.calculateDaysAtSea(
              item.start_date,
              item.end_date,
            );

            item.totalFuelLg =
              (item.total_fuel_gain || 0) - (item.total_fuel_loss || 0);

            item.totalTimeLg =
              (item.total_time_gain || 0) - (item.total_time_loss || 0);

            item.gwAvgDailyCons = this.calculateGwAvgDailyCons(
              item.gw_fo_cons,
              item.gw_cons_go,
              item.gw_time,
            );

            item.start_date = this.formatStartEndDate(item.start_date);

            item.end_date = this.formatStartEndDate(item.end_date);

            item.pdf_created = this.formatDate(item.pdf_created);

            item.segment = this.normalizeSegment(item.segment);

            return item;
          });

          // =========================
          // FRONTEND FILTERS
          // =========================

          let finalData = [...processed];
          // debugger
          // // ✅ TYPE OF SHIP
          if (filters?.type_of_ship && filters.type_of_ship !== 'ALL') {
            const selectedType = filters.type_of_ship
              ?.toString()
              .trim()
              .toLowerCase();

            finalData = finalData.filter((item: any) => {
              const itemType = item.type_of_ship
                ?.toString()
                .trim()
                .toLowerCase();

              return itemType === selectedType;
            });
          }

          // // ✅ VOYAGE TYPE
          // if (filters?.voyage_type && filters.voyage_type !== 'ALL') {
          //   finalData = finalData.filter(
          //     (item: any) => item.voyage_type === filters.voyage_type,
          //   );
          // }

          // // ✅ VESSEL STATUS
          // if (filters?.vessel_status && filters.vessel_status !== 'ALL') {
          //   finalData = finalData.filter(
          //     (item: any) => item.vessel_status === filters.vessel_status,
          //   );
          // }

          // // ✅ SEGMENT
          // if (filters?.segment && filters.segment !== 'ALL') {
          //   finalData = finalData.filter(
          //     (item: any) =>
          //       item.segment?.trim().toLowerCase() ===
          //       filters.segment?.trim().toLowerCase(),
          //   );
          // }

          // // ✅ SHIP NAMES
          // if (filters?.vessel_names?.length) {
          //   const lowerVesselNames = filters.vessel_names.map((n: string) =>
          //     n?.trim().toLowerCase(),
          //   );

          //   finalData = finalData.filter(
          //     (item: any) =>
          //       item.vessel_name &&
          //       lowerVesselNames.includes(
          //         item.vessel_name.trim().toLowerCase(),
          //       ),
          //   );
          // }

          // =========================
          // UPDATE TABLE DATA
          // =========================

          this.elements = [...finalData];

          this.filteredData = [...finalData];

          this.paginatedData = [...finalData];
          this.filteredCountValue = response.total_count;

          // =========================
          // PAGINATION
          // =========================
          if (this.latestStats?.total_voyages !== undefined) {
            this.totalRecords = Number(this.latestStats.total_voyages || 0);
          } else {
            this.totalRecords = finalData.length;
          }
          this.updatePageSizeOptions(this.totalRecords);

          this.currentPage = page - 1;

          if (this.paginator) {
            this.paginator.length = this.totalRecords;

            this.paginator.pageIndex = this.currentPage;
          }

          // =========================
          // FINAL UI
          // =========================

          this.isLoadingTable = false;

          if (this.paginatedData.length === 0) {
            this.loadingMessage = 'No records found.';
          }

          if (this.tableContainer) {
            this.tableContainer.nativeElement.scrollTop = 0;
          }

          console.log('FINAL FILTERED DATA =>', finalData);

          this.cdr.detectChanges();
        },

        error: (err) => {
          this.loadingMessage = 'Failed to load data. Please try again later.';

          console.error('Failed to load paginated data', err);

          this.isLoadingTable = false;

          this.cdr.detectChanges();
        },
      });
  }

   formatStartEndDate(dateString:any) {
 if (!dateString) return '';
  const [datePart, timePart] = dateString.split('T');
  const [year, month, day] = datePart.split('-');
  const time = timePart.slice(0, 5); // extracts HH:mm
  
  return `${day}-${month}-${year} ${time}`;
}
  normalizeSegment(segment: string): string {
    const validSegments = ['LR1', 'LR2', 'LR3', 'VLCC', 'MR2'];
    if (!segment) return segment;

    let seg = segment.toString().trim();

    if (seg.toUpperCase() === 'MR') {
      return 'MR2';
    } else if (validSegments.includes(seg.toUpperCase())) {
      return seg.toUpperCase();
    } else {
      return seg.charAt(0).toUpperCase() + seg.slice(1).toLowerCase();
    }
  }
  sortLadenChart(condition: any) {
    if (condition) {
      this.isSorting = true;
      this.sortMapData = !this.sortMapData;
      this.azsort = false;
    }

    this.onSegmentChange(condition);
  }
  azSortChart(condition: any) {
    if (condition) {
      this.azsort = true;
      this.isAscending = !this.isAscending;
      this.isSorting = false;
    }
    this.onSegmentChange(condition);
  }

  getDataCounts(data: any) {
    this.totalVoyages = data.length;
    const uniqueVesselsMap = new Map<string, any>();
    data.forEach((vessel: any) => {
      if (!uniqueVesselsMap.has(vessel.vessel_name)) {
        uniqueVesselsMap.set(vessel.vessel_name, vessel);
      }
    });
    const uniqueVessels = Array.from(uniqueVesselsMap.values());
    this.totalVessels = uniqueVessels.length;
    this.activeVessels = uniqueVessels.filter(
      (vessel: any) => vessel.vessel_status === 'Active',
    ).length;
    this.inactiveVessels = uniqueVessels.filter(
      (vessel: any) => vessel.vessel_status === 'Inactive',
    ).length;
    this.underPerformanceFuel = data.filter((vessel: any) => {
      const totalFuelLg =
        (vessel.total_fuel_gain || 0) - (vessel.total_fuel_loss || 0);
      return totalFuelLg < 0;
    }).length;
    this.underPerformanceTime = data.filter((vessel: any) => {
      const totalTimeLg =
        (vessel.total_time_gain || 0) - (vessel.total_time_loss || 0);
      return totalTimeLg < 0;
    }).length;
    this.underPerformanceFuelVessels = data
      .filter((vessel: any) => {
        const totalFuelLg =
          (vessel.total_fuel_gain || 0) - (vessel.total_fuel_loss || 0);
        return totalFuelLg < 0;
      })
      .slice(0, 5) // Limit to 5 vessels
      .map((vessel: any) => vessel.vessel_name); // Assuming vessel has a 'name' property

    this.underPerformanceTimeVessels = data
      .filter((vessel: any) => {
        const totalTimeLg =
          (vessel.total_time_gain || 0) - (vessel.total_time_loss || 0);
        return totalTimeLg < 0;
      })
      .slice(0, 5) // Limit to 5 vessels
      .map((vessel: any) => vessel.vessel_name); // Assuming vessel has a 'name' property

    this.fuelTooltipContent =
      this.underPerformanceFuelVessels.length > 5
        ? this.underPerformanceFuelVessels.slice(0, 5).join(', ') + ', ...'
        : this.underPerformanceFuelVessels.join(', ');

    this.timeTooltipContent =
      this.underPerformanceTimeVessels.length > 5
        ? this.underPerformanceTimeVessels.slice(0, 5).join(', ') + ', ...'
        : this.underPerformanceTimeVessels.join(', ');
  }
  // vessel_name

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, sort.active, isAsc);
    });
  }

  compare(a: any, b: any, sortActive: string, isAsc: boolean) {
    if (a[sortActive] === null || a[sortActive] === undefined) {
      return isAsc ? -1 : 1;
    }
    if (b[sortActive] === null || b[sortActive] === undefined) {
      return isAsc ? 1 : -1;
    }

    // Handle date strings in display format: "DD - MM - YY HH:MM"
    if (
      typeof a[sortActive] === 'string' &&
      typeof b[sortActive] === 'string'
    ) {
      const aDate = this.parseDisplayDate(a[sortActive]);
      const bDate = this.parseDisplayDate(b[sortActive]);
      if (aDate && bDate) {
        return (aDate.getTime() - bDate.getTime()) * (isAsc ? 1 : -1);
      }
    }

    // Handle numeric values
    if (
      typeof a[sortActive] === 'number' &&
      typeof b[sortActive] === 'number'
    ) {
      return (a[sortActive] - b[sortActive]) * (isAsc ? 1 : -1);
    }

    // Parse strings as numbers if applicable
    const aNum = parseFloat(a[sortActive]);
    const bNum = parseFloat(b[sortActive]);
    if (!isNaN(aNum) && !isNaN(bNum)) {
      return (aNum < bNum ? -1 : 1) * (isAsc ? 1 : -1);
    }

    // Handle string sorting
    if (
      typeof a[sortActive] === 'string' &&
      typeof b[sortActive] === 'string'
    ) {
      return a[sortActive].localeCompare(b[sortActive]) * (isAsc ? 1 : -1);
    }

    // Fallback for other types
    return (a[sortActive] < b[sortActive] ? -1 : 1) * (isAsc ? 1 : -1);
  }

  paginateData() {
    this.getDataCounts(this.elements);
    this.loadSegments();
  }
  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
    const year = date.getUTCFullYear().toString().slice(-2); // Get last two digits of the year
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    return `${day} - ${month} - ${year} ${hours}:${minutes}`;
  }
  private parseDisplayDate(value: string): Date | null {
    const match = value
      ?.toString()
      .trim()
      .match(/^(\d{2})\s*-\s*(\d{2})\s*-\s*(\d{2})\s+(\d{2}):(\d{2})$/);

    if (!match) {
      return null;
    }

    const [, dd, mm, yy, hh, min] = match;
    return new Date(
      Date.UTC(
        Number(`20${yy}`),
        Number(mm) - 1,
        Number(dd),
        Number(hh),
        Number(min),
      ),
    );
  }

  calculateDaysAtSea(startDate: string, endDate: string): number {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Calculate the difference in milliseconds
    const diffInMs = end.getTime() - start.getTime();

    // Convert the difference from milliseconds to days (1 day = 24 * 60 * 60 * 1000 milliseconds)
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return Math.floor(diffInDays); // Round down to the nearest whole day
  }

  calculateGwAvgDailyCons(
    gw_fo_cons: number,
    gw_cons_go: number,
    gw_time: number,
  ): number {
    if (gw_time > 0) {
      // Calculate the average daily consumption
      return ((gw_fo_cons + gw_cons_go) / gw_time) * 24;
    }
    return 0; // Return 0 if gw_time is 0 or invalid
  }

  clearClick() {
    this.suppressFilterCascade = true;
    this.filterForm.reset();

    this.filterForm.patchValue({
      clientStatus: null,
      condition: 'ALL',
      vesselStatus: 'ALL',
      type_of_ship: 'ALL',
      segment: 'ALL',
      type_speed: 'ALL',
      technical_operator: 'ALL',
      commercial_operator: 'ALL',
    });

    this.filteredData = null;
    this.shipNameSuggestions = [];
    this.dropdownOpen = false;
    this.selectedShips = [];
    this.selectedClients = [];
    this.selectedShipLabel = 'Select a ship';
    this.selectedClientLabel = '';
    this.apiClientOptions = [];
    this.vesselNameOptions = [];
    this.segmentOptions = ['ALL'];
    this.statusOptions = ['ALL'];
    this.conditionOptions = ['ALL'];
    this.typeofshipOptions = ['ALL'];
    this.typeofSpeedOptions = ['ALL'];
    this.technicalOperatorOptions = ['ALL'];
    this.commercialOperatorOptions = ['ALL'];

    this.currentPage = 0;
    this.paginatedData = [];

    this.isSorting = false;
    this.sortMapData = false;
    this.azsort = false;
    this.isAscending = false;
    this.latestStats = null;
    this.showFilteredCount = false;
    this.filteredCountValue = 0;
    this.suppressFilterCascade = false;

    this.loadFilterOptions();
    this.loadStats();
    this.loadAllDataPaginated(1);
    this.loadStatSegments();
  }

  selectedShipLabel: string = 'Select a ship';

  private getClientFilter(selectedClients: string[]): (item: any) => boolean {
    const group = ['Eiger', 'Northwell'];

    return (item: any) => {
      const clientName = (item.client_name || '').trim().toLowerCase();

      return selectedClients.some((selected) => {
        if (group.includes(selected)) {
          return group.map((g) => g.toLowerCase()).includes(clientName);
        }
        return clientName === selected.toLowerCase();
      });
    };
  }

  filterShipNames(event: Event): void {
  const inputValue = (event.target as HTMLInputElement).value
    .trim()
    .toLowerCase();

  const segment = this.filterForm.get('segment')?.value?.trim().toLowerCase();
  const selectedClients = this.selectedClients || [];

  const clientFilter =
    selectedClients.length > 0
      ? this.getClientFilter(selectedClients)
      : () => true;

  const sourceList =
    this.allVessels.length > 0 ? this.allVessels : this.elements;

  const uniqueSuggestions = new Map<string, any>();

  (sourceList || []).forEach((item: any) => {
    const rawName = (item.vessel_name || '').trim();
    if (!rawName) return;

    const upperName = rawName.toUpperCase();
    const lowerName = rawName.toLowerCase();
    const itemSegment = (item.segment || '').trim().toLowerCase();

    const segmentMatches =
      !segment || itemSegment === segment || segment === 'all';
    const clientMatches = clientFilter(item);
    const nameMatches = lowerName.includes(inputValue);

    if (segmentMatches && clientMatches && nameMatches && !uniqueSuggestions.has(upperName)) {
      uniqueSuggestions.set(upperName, {
        ...item,
        vessel_name: upperName
      });
    }
  });

  this.shipNameSuggestions = Array.from(uniqueSuggestions.values()).sort(
    (a: any, b: any) => a.vessel_name.localeCompare(b.vessel_name)
  );

  this.dropdownOpen = this.shipNameSuggestions.length > 0;
}

  onFocusShipInput(): void {
  const segment = this.filterForm.get('segment')?.value?.trim().toLowerCase();
  const selectedClients = this.selectedClients || [];

  const clientFilter =
    selectedClients.length > 0
      ? this.getClientFilter(selectedClients)
      : () => true;

  const sourceList =
    this.allVessels.length > 0 ? this.allVessels : this.elements;

  const uniqueSuggestions = new Map<string, any>();

  (sourceList || []).forEach((item: any) => {
    const rawName = (item.vessel_name || '').trim();
    if (!rawName) return;

    const upperName = rawName.toUpperCase();
    const itemSegment = (item.segment || '').trim().toLowerCase();

    const segmentMatches =
      !segment || itemSegment === segment || segment === 'all';
    const clientMatches = clientFilter(item);

    if (segmentMatches && clientMatches && !uniqueSuggestions.has(upperName)) {
      uniqueSuggestions.set(upperName, {
        ...item,
        vessel_name: upperName
      });
    }
  });

  this.shipNameSuggestions = Array.from(uniqueSuggestions.values()).sort(
    (a: any, b: any) => a.vessel_name.localeCompare(b.vessel_name)
  );

  this.dropdownOpen = this.shipNameSuggestions.length > 0;
}

  onBlurShipInput(): void {
    // Delay closing to allow checkbox click.
    // Increased to 400ms for stability.
    setTimeout(() => {
      this.dropdownOpen = false;
    }, 400);
  }

  fetchAllVessels() {
    this.isLoadingVessels = true;
    this.sharedDataService
      .getLookerVessels(this.username)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.allVessels = res || [];
          this.isLoadingVessels = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Failed to load vessels', err);
          this.isLoadingVessels = false;
          this.cdr.detectChanges();
        },
      });
  }

  onShipCheckboxChange(event: Event, shipName: string): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      if (!this.selectedShips.includes(shipName)) {
        this.selectedShips.push(shipName);
      }
    } else {
      this.selectedShips = this.selectedShips.filter(
        (name) => name !== shipName,
      );
    }

    this.selectedShipLabel = this.selectedShips.join(', ');
  }
  convertDate(inputDate: string): string {
    if (!inputDate?.trim()) return '';
    const date = new Date(inputDate); // Convert string to Date object

    // Format the date as YYYY-MM-DD
    const formattedDate = date.toISOString().split('T')[0];

    return formattedDate;
  }
  formatCustomDate(dateStr: string): string {
    if (!dateStr?.trim() || dateStr === 'NaT') return '';

    // Match pattern like "12 - 04 - 25 21:00-UTC"
    const match = dateStr.match(
      /^(\d{2})\s*-\s*(\d{2})\s*-\s*(\d{2})\s+(\d{2}):(\d{2})$/,
    );
    if (!match) return '';

    const [_, dd, mm, yy, hh, min] = match;
    const year = `20${yy}`; // assume 20xx
    const month = mm.padStart(2, '0');
    const day = dd.padStart(2, '0');
    const hour = hh.padStart(2, '0');
    const minute = min.padStart(2, '0');

    // Return normalized string for comparison
    return `${year}-${month}-${day}`;
  }
  formatPdfCreatedCustomDate(dateStr: string): string {
    if (!dateStr?.trim() || dateStr === 'NaT') return '';

    const parsedDate = new Date(dateStr);
    if (isNaN(parsedDate.getTime())) return 'Invalid date';

    // Format to YYYY-MM-DD
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  filterClick() {
    this.currentPage = 0;
    this.paginatedData = [];
    this.filteredData = [];

    const filters = this.buildTableFilters();
    const hasActiveFilters = Object.values(filters).some((value: any) =>
      Array.isArray(value) ? value.length > 0 : !!value,
    );
    this.showFilteredCount = hasActiveFilters;

    if (
      (filters.from_date && !filters.to_date) ||
      (!filters.from_date && filters.to_date)
    ) {
      this.toastr.info(ToasterMessages.SelectDate);
      return;
    }
    if (
      (filters.report_from && !filters.report_to) ||
      (!filters.report_from && filters.report_to)
    ) {
      this.toastr.info(ToasterMessages.SelectDate);
      return;
    }

    this.latestStats = null;
    this.loadStats(filters);
    this.loadAllDataPaginated(1, filters);
    // this.loadStatSegments();
    this.dropdownOpen = false;
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  onPageChange(event: PageEvent) {
    this.itemsPerPage = event.pageSize;
    const filters = this.buildTableFilters();

    this.loadAllDataPaginated(event.pageIndex + 1, filters);
  }
  private updatePageSizeOptions(total: number) {
    const baseOptions = [25, 50, 100];
    const safeTotal = Number(total || 0);
    const dynamicOptions =
      safeTotal > 0 ? [...baseOptions, safeTotal] : baseOptions;
    this.pageSizeOptions = Array.from(new Set(dynamicOptions)).sort(
      (a, b) => a - b,
    );
  }
  getColor(value: number): string {
    if (value > 0) {
      return '#a8d296'; // Positive values in green
    } else if (value < 0) {
      return '#ff9090'; // Negative values in red
    }
    return 'inherit'; // Default color for zero
  }
  getVesselNameColor(totalFuelLg: number, totalTimeLg: number): string {
    return totalFuelLg < 0 || totalTimeLg < 0 ? 'red' : '';
  }

  toggleMapView() {
    this.graph = !this.graph;
    this.loadSegments();
    localStorage.removeItem('mapToggle');
  }

  downloadClick() {
    const from_date_str = this.filterForm.get('from_date')?.value;
    const to_date_str = this.filterForm.get('to_date')?.value;
    const client = this.filterForm.get('client')?.value;

    // function formatDate(dateInput: any): string {
    //   const d = new Date(dateInput);
    //   const pad = (num: number) => num.toString().padStart(2, '0');

    //   const year = d.getFullYear();
    //   const month = pad(d.getMonth() + 1);
    //   const day = pad(d.getDate());
    //   const hours = pad(d.getHours());
    //   const minutes = pad(d.getMinutes());
    //   const seconds = pad(d.getSeconds());

    //   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    // }
    // const from_date_str = formatDate(from_date_val);
    // const to_date_str = formatDate(to_date_val);
    const ship =
      this.selectedShips && this.selectedShips.length > 0
        ? this.selectedShips[0]
        : this.filteredData?.[0]?.vessel_name || '';
    let payload = {
      vessel_name: ship,
      imo: this.filteredData?.[0]?.imo || '',
      client: client,
      from_date: from_date_str,
      to_date: to_date_str,
    };
    const dialogRef = this.dialog.open(DownloadPopupComponent, {
      // width: '400px',

      disableClose: true,
      data: payload,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'csv') {
        const data = this.filteredData || this.elements;

        // Define the columns for your Excel-like format
        const csvHeader = [
          'Ship Name',
          'I.M.O Number',
          'Year Built',
          'Type Of Ship',
          'Segment',
          'Meraki PIC',
          'Start Port',
          'Start Time',
          'End Port',
          'End Time',
          'Condition',
          'Generated Date',
          'CP Speed',
          'Cp Consumption',
          'Days At Sea',
          'Total Fuel L/G',
          'Total Time L/G',
          'Total Dist.',
          'Total Time',
          'Total Bunker Cons',
          'Average Speed',
          'Total Avg Daily Cons',
          'Gw Distance',
          'GW Time',
          'GW Pct.',
          'GW Avg Speed',
          'GW Consumption',
          'GW Avg Daily Cons',
          'Adverse Wx Dist.',
          'Adverse Wx Time',
          'Avg Speed in Adverse Wx Time',
          'Avg Cons in Adverse Wx Time',
        ];

        // Map the data to match the Excel format
        const csvData = data
          .map((item: any, index: any) => [
            item.vessel_name,
            item.imo,
            item.year_built,
            item.type_of_ship,
            item.segment,
            item.pic,
            item.start_port,
            item.start_date,
            item.end_port,
            item.end_date,
            item.voyage_type,
            item.pdf_created,
            item.cp_speed,
            item.cp_consumption,
            item.daysAtSea,
            item.totalFuelLg,
            item.totalTimeLg,
            item.total_distance,
            item.total_time,
            item.total_bunkers_consumed_at_sea,
            item.avg_speed,
            item.total_avg_daily_cons,
            item.gw_distance,
            item.gw_time,
            item.GW_Pcx,
            item.avg_speed_in_gw,
            item.GW_cons,
            item.gwAvgDailyCons,
            item.adverse_weather_distance,
            item.adverse_weather_time,
            item.avg_speed_in_adverse_wx,
            item.avg_cons_in_adverser_wx,
          ])
          .join('\n');

        // Create CSV content to mimic an Excel sheet structure
        const csvContent = `${csvHeader}\n${csvData}`;
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Database.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    });
  }
  calculateAverages(data: any) {
    const groupedData: {
      [key: string]: {
        avgSpeeds: number[];
        perfSpeeds: number[];
        avgDailyCons: number[];
        cpConsumptions: number[];
        totalDistance: number;
        totalTimeLoss: number;
        totalTimeGain: number;
        totalFuelLoss: number;
        totalFuelGain: number;
      };
    } = {};

    const segmentSpeeds: number[] = [];

    data.forEach((entry: any) => {
      const key = `${entry.vessel_name}-${entry.segment}`;

      if (!groupedData[key]) {
        groupedData[key] = {
          avgSpeeds: [],
          perfSpeeds: [],
          avgDailyCons: [],
          cpConsumptions: [],
          totalDistance: 0,
          totalTimeLoss: 0,
          totalTimeGain: 0,
          totalFuelLoss: 0,
          totalFuelGain: 0,
        };
      }

      groupedData[key].avgSpeeds.push(entry.avg_speed);
      groupedData[key].perfSpeeds.push(entry.perf_speed);
      groupedData[key].avgDailyCons.push(entry.total_avg_daily_cons);
      groupedData[key].cpConsumptions.push(entry.cp_consumption);

      groupedData[key].totalDistance += entry.total_distance;
      groupedData[key].totalTimeLoss += entry.total_time_loss || 0;
      groupedData[key].totalTimeGain += entry.total_time_gain || 0;
      groupedData[key].totalFuelLoss += entry.total_fuel_loss || 0;
      groupedData[key].totalFuelGain += entry.total_fuel_gain || 0;

      segmentSpeeds.push(entry.avg_speed);
    });

    const segmentAvgSpeed =
      data[0]?.segment_avg_speed !== undefined &&
      data[0]?.segment_avg_speed !== null
        ? Number(data[0].segment_avg_speed.toFixed(2))
        : Number(
            (
              segmentSpeeds.reduce((sum, speed) => sum + speed, 0) /
              (segmentSpeeds.length || 1)
            ).toFixed(2),
          );

    const results: any[] = [];
    let totalConsAtAvgSegSpeed = 0;
    let countConsAtAvgSegSpeed = 0;

    Object.entries(groupedData).forEach(([key, values]) => {
      const [vessel, segment] = key.split('-');

      const averageSpeed = Number(
        (
          values.avgSpeeds.reduce((sum, speed) => sum + speed, 0) /
          values.avgSpeeds.length
        ).toFixed(2),
      );

      const averagePerfSpeed = Number(
        (
          values.perfSpeeds.reduce((sum, speed) => sum + speed, 0) /
          values.perfSpeeds.length
        ).toFixed(2),
      );

      const averageDailyCons = Number(
        (
          values.avgDailyCons.reduce((sum, cons) => sum + cons, 0) /
          values.avgDailyCons.length
        ).toFixed(2),
      );

      const averageCpConsumption = values.cpConsumptions[0];

      const consAtAvgSegSpeed = Number(
        (
          ((averageDailyCons ?? 0) / (averageSpeed || 1)) *
          (segmentAvgSpeed ?? 0)
        ).toFixed(2),
      );

      totalConsAtAvgSegSpeed += consAtAvgSegSpeed;
      countConsAtAvgSegSpeed++;

      results.push({
        vessel,
        segment,
        averageSpeed,
        averagePerfSpeed,
        averageDailyCons,
        averageCpConsumption,
        totalDistance: values.totalDistance,
        segmentAvgSpeed,
        consAtAvgSegSpeed,
        average: 0,
        totalTimeLoss: values.totalTimeLoss,
        totalTimeGain: values.totalTimeGain,
        totalFuelLoss: values.totalFuelLoss,
        totalFuelGain: values.totalFuelGain,
      });
    });

    const averageConsAtAvgSegSpeed = Number(
      (totalConsAtAvgSegSpeed / countConsAtAvgSegSpeed).toFixed(2),
    );

    results.forEach((result) => {
      result.average = averageConsAtAvgSegSpeed;
    });

    return results;
  }
  loadSegments() {
    // Fetch initial charts if segments exist
    if (this.ladenSelectedSegment)
      this.fetchChartData('Laden', this.ladenSelectedSegment);
    if (this.ballastSelectedSegment)
      this.fetchChartData('Ballast', this.ballastSelectedSegment);
    if (this.bothSelectedSegment)
      this.fetchChartData('both', this.bothSelectedSegment);
  }

  // Modified to trigger API calls on dropdown change
  onSegmentChange(condition: string) {
    let segment = '';
    if (condition === 'Laden') segment = this.ladenSelectedSegment;
    else if (condition === 'Ballast') segment = this.ballastSelectedSegment;
    else if (condition === 'both') segment = this.bothSelectedSegment;

    if (segment) {
      this.fetchChartData(condition, segment);
    }
  }

  // Get unique segments for a given condition
  getSegmentsForCondition(
    condition: string,
    selectedTypeOfShip: string,
    data: any,
  ): string[] {
    if (!Array.isArray(data) || !selectedTypeOfShip) return [];

    // Allowed segments for the selected ship type
    const allowedSegments =
      this.segmentMapping[selectedTypeOfShip]?.map((s) =>
        s.value.toLowerCase(),
      ) || [];

    return Array.from(
      new Set(
        data
          .filter(
            (item: any) =>
              item.voyage_type === condition &&
              item.type_of_ship === selectedTypeOfShip &&
              item.segment &&
              allowedSegments.includes(item.segment.trim().toLowerCase()),
          )
          .map((item: any) => item.segment.trim()),
      ),
    );
  }
  // segmentMapping: { [key: string]: { label: string; value: string }[] } = {
  //   'Bulk carrier': [
  //     { label: 'Coaster', value: 'Coaster' },
  //     { label: 'Handysize', value: 'Handysize' },
  //     { label: 'Handymax', value: 'Handymax' },
  //     { label: 'Supramax', value: 'Supramax' },
  //     { label: 'Ultramax', value: 'Ultramax' },
  //     { label: 'Panamax', value: 'Panamax' },
  //     { label: 'Kamsarmax', value: 'Kamsarmax' },
  //     { label: 'Ultra Panamax', value: 'Ultrapanamax' },
  //     { label: 'Capesize', value: 'Capesize' },
  //     { label: 'Very Large Ore Carrier', value: 'VLOC' },
  //     { label: 'Chinamax', value: 'Chinamax' },
  //   ],
  //   Tanker: [
  //     { label: 'Coastal', value: 'Coastal' },
  //     { label: 'Intermediate', value: 'Intermediate' },
  //     { label: 'Handytankers', value: 'Handytankers' },
  //     { label: 'MR', value: 'MR' },
  //     { label: 'LR1 / Panamax', value: 'LR1/Panamax' },
  //     { label: 'LR2 / Aframax', value: 'LR2/Aframax' },
  //     { label: 'LR3 / Suezmax', value: 'LR3/Suezmax' },
  //     { label: 'VLCC', value: 'VLCC' },
  //   ],
  //   'Gas Tanker': [
  //     { label: 'Coasters', value: 'Coasters' },
  //     { label: 'Handysize', value: 'Handysize' },
  //     { label: 'MGC', value: 'MGC' },
  //     { label: 'LGC', value: 'LGC' },
  //     { label: 'VLGC', value: 'VLGC' },
  //     { label: 'VLEC', value: 'VLEC' },
  //   ],
  //   'Container ship': [],
  //   'General cargo': [],
  //   'Passenger ship': [],
  // };
  //  typeofshipOptions = [
  //   { label: 'ALL', value: 'ALL' },
  //   { label: 'Bulk carrier', value: 'Bulk carrier' },
  //   { label: 'Container ship', value: 'Container ship' },
  //   { label: 'General cargo', value: 'General cargo' },
  //   { label: 'Passenger ship', value: 'Passenger ship' },
  //   { label: 'Tanker', value: 'Tanker' },
  //   { label: 'Gas Tanker', value: 'Gas Tanker' },
  // ];
  getTypeOfShipForCondition(condition: string, data: any): string[] {
    if (!Array.isArray(data)) return [];

    return Array.from(
      new Set(
        data
          .filter(
            (item: any) => item.voyage_type === condition && item.type_of_ship,
          )
          .map((item: any) => item.type_of_ship.trim()),
      ),
    );
  }

  getBothSegmentsForCondition(data: any): string[] {
    if (!Array.isArray(data)) return [];
    return Array.from(
      new Set(
        data
          .filter((item: any) => item.segment) // filter null/empty
          .map((item: any) => item.segment.trim()),
      ),
    );
  }
  onTypeOfShipChange(condition: string) {
    if (condition === 'Ballast') {
      const allowedSegments =
        this.segmentMapping[this.ballastSelectedTypeOfShip] || [];

      this.ballastSegments = this.apiBallastSegments.filter((seg: any) =>
        allowedSegments.includes(seg),
      );

      this.ballastSelectedSegment =
        this.ballastSegments.length > 0 ? this.ballastSegments[0] : null;

      if (this.ballastSelectedSegment) {
        this.fetchChartData(condition, this.ballastSelectedSegment);
      }
    }

    if (condition === 'Laden') {
      const allowedSegments =
        this.segmentMapping[this.ladenSelectedTypeOfShip] || [];

      this.ladenSegments = this.apiLadenSegments.filter((seg: any) =>
        allowedSegments.includes(seg),
      );

      this.ladenSelectedSegment =
        this.ladenSegments.length > 0 ? this.ladenSegments[0] : null;

      if (this.ladenSelectedSegment) {
        this.fetchChartData(condition, this.ladenSelectedSegment);
      }
    }
  }

  createChart(title: string, data: any[]) {
    let sortedData = data.sort((a, b) => a.vessel.localeCompare(b.vessel));
    if (this.sortMapData && this.isSorting) {
      sortedData = sortedData.sort(
        (a, b) => b.consAtAvgSegSpeed - a.consAtAvgSegSpeed,
      );
    } else if (this.isSorting && !this.sortMapData) {
      // Sort from small to large
      sortedData = sortedData.sort(
        (a, b) => a.consAtAvgSegSpeed - b.consAtAvgSegSpeed,
      );
    }
    if (this.isAscending && this.azsort) {
      sortedData = sortedData.sort((a, b) => a.vessel.localeCompare(b.vessel));
    } else if (this.azsort && !this.isAscending) {
      sortedData = sortedData.sort((a, b) => b.vessel.localeCompare(a.vessel));
    }
    const vesselNames = sortedData.map((item) => item.vessel);
    const averageValue = Number(
      (
        data.reduce((sum, item) => sum + item.consAtAvgSegSpeed, 0) /
        data.length
      ).toFixed(2),
    );
    const segAvgSpeed = Number(
      (
        data.reduce((sum, item) => sum + item.segmentAvgSpeed, 0) / data.length
      ).toFixed(2),
    );
    const perfAvgSpeed = Number(
      (
        data.reduce((sum, item) => sum + (item.averagePerfSpeed || 0), 0) /
        data.length
      ).toFixed(2),
    );

    const consumptionData = sortedData.map((item) => ({
      y: item.consAtAvgSegSpeed,
      totalDistance: item.totalDistance * 0.621371,
    }));

    return new Chart({
      chart: {
        type: 'column',
        backgroundColor: '#20283c',
      },

      title: {
        text: title,
        style: {
          fontFamily: 'Poppins, sans-serif',
          color: '#dedbdb',
        },
      },

      xAxis: {
        categories: vesselNames,
        title: {
          text: 'Vessel Names',
          style: {
            fontFamily: 'Poppins, sans-serif',
            color: '#dedbdb',
          },
        },
        labels: {
          rotation: -90,
          y: 3,
          style: {
            fontSize: '12px',
            fontFamily: 'Poppins, sans-serif',
            color: '#dedbdb',
          },
          useHTML: true,
          formatter: function () {
            const name = this.value as string;
            return `<span title="${name}">${
              name.length > 6 ? name.slice(0, 10) + '…' : name
            }</span>`;
          },
        },
      },

      yAxis: [
        {
          min: 0,
          title: {
            text: 'Consumption(MT)',
            style: {
              fontFamily: 'Poppins, sans-serif',
              color: '#dedbdb',
            },
          },
          labels: {
            style: {
              fontFamily: 'Poppins, sans-serif',
              color: '#dedbdb',
            },
          },

          plotLines: [
            {
              color: '#ff9e32',
              value: averageValue,
              width: 2,
              dashStyle: 'Dash',
              zIndex: 5,
              label: {
                text: `Average: ${averageValue} MT`,
                align: 'right',
                style: {
                  color: '#ff9e32',
                  fontSize: '12px',
                  fontFamily: 'Poppins, sans-serif',
                },
              },
            },
          ],
        },

        {
          opposite: true,
          min: 0,
          max: Math.max(segAvgSpeed || 0, perfAvgSpeed || 0) * 1.2,

          title: {
            text: 'Speed (Kts)',
            style: {
              fontFamily: 'Poppins, sans-serif',
              color: '#dedbdb',
            },
          },

          labels: {
            style: {
              fontFamily: 'Poppins, sans-serif',
              color: '#dedbdb',
            },
          },

          plotLines: [
            {
              color: '#fafd6e',
              value: segAvgSpeed,
              width: 2,
              dashStyle: 'Dash',
              zIndex: 5,
              label: {
                text: `Segment Avg Speed: ${segAvgSpeed} Kts`,
                align: 'right',
                style: {
                  color: '#fafd6e',
                  fontSize: '12px',
                  fontFamily: 'Poppins, sans-serif',
                },
              },
            },
            {
              color: '#00e6a8',
              value: perfAvgSpeed,
              width: 2,
              dashStyle: 'Dash',
              zIndex: 5,
              label: {
                text: `Perf Avg Speed: ${perfAvgSpeed} Kts`,
                align: 'right',
                style: {
                  color: '#00e6a8',
                  fontSize: '12px',
                  fontFamily: 'Poppins, sans-serif',
                },
              },
            },
          ],
        },
      ],

      tooltip: {
        formatter: function () {
          const point = this.point as Highcharts.Point & {
            totalDistance?: number;
          };

          const dist = point.totalDistance
            ? point.totalDistance.toFixed(2)
            : 'N/A';

          const isSpeed = this.series.name.toLowerCase().includes('speed');
          const unit = isSpeed ? 'Kts' : 'MT';

          if (this.series.name === 'Consumption') {
            return `
          <b>${this.x}</b><br>
          <span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y} MT</b><br>
          <span style="color:red">\u25CF</span> Average: <b>${averageValue} MT</b><br>
          <span style="color:#9d0023">\u25CF</span> Segment Avg Speed: <b>${segAvgSpeed} Kts</b><br>
          <span style="color:#00e6a8">\u25CF</span> Perf Avg Speed: <b>${perfAvgSpeed} Kts</b><br>
          <span style="color:blue">\u25CF</span> Total Distance: <b>${dist} miles</b>
        `;
          } else {
            return `
          <b>${this.x}</b><br>
          <span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y} ${unit}</b><br>
          <span style="color:blue">\u25CF</span> Total Distance: <b>${dist} miles</b>
        `;
          }
        },
      },

      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            style: {
              fontFamily: 'Poppins, sans-serif',
              color: '#dedbdb',
            },
          },
          events: {
            legendItemClick: function () {
              return false;
            },
          },
        },
      },

      legend: {
        enabled: true,
        itemStyle: {
          fontFamily: 'Poppins, sans-serif',
          color: '#dedbdb',
        },
      },

      credits: {
        enabled: false,
      },

      series: [
        {
          name: 'Consumption',
          type: 'column',
          color: '#104177',
          data: consumptionData,
          yAxis: 0,
        },

        {
          name: 'Average',
          type: 'line',
          color: '#ff9e32',
          dashStyle: 'Dash',
          marker: { enabled: false },
          data: new Array(sortedData.length).fill(averageValue),
          yAxis: 0,
        },

        // ✅ ADDED: Segment Avg Speed (VISIBLE IN LEGEND)
        {
          name: 'Segment Avg Speed',
          type: 'line',
          color: '#fafd6e',
          dashStyle: 'Dash',
          marker: { enabled: false },
          data: new Array(sortedData.length).fill(segAvgSpeed),
          yAxis: 1,
        },

        // ✅ ADDED: Perf Avg Speed (VISIBLE IN LEGEND)
        {
          name: 'Perf Avg Speed',
          type: 'line',
          color: '#00e6a8',
          dashStyle: 'Dash',
          marker: { enabled: false },
          data: new Array(sortedData.length).fill(perfAvgSpeed),
          yAxis: 1,
        },
      ],
    });
  }
  downloadCSV(type: string) {
    // Example data based on "laden" argument (Replace this with actual data)
    let data: any;
    if (type === 'laden') {
      data = this.ladenData;
    } else if (type === 'ballast') {
      data = this.ballastData;
    } else {
      data = this.bothData;
    }
    const headers = [
      'Vessel',
      'Segment',
      'Vessel Avg Speed',
      'Vessel Avg Daily Cons',
      'Segment Avg Speed',
      'Cons at Avg Seg Speed',
      'Cp Consumption',
      'Total Time Loss',
      'Total Time Gain',
      'Total Fuel Loss',
      'Total Fuel Gain',
      // 'Average'
    ];

    // Convert JSON data to CSV format
    let csvContent = 'data:text/csv;charset=utf-8,' + headers.join(',') + '\n';

    data.forEach((row: any) => {
      const values = [
        row.vessel,
        row.segment,
        row.averageSpeed,
        row.averageDailyCons,
        row.segmentAvgSpeed,
        row.consAtAvgSegSpeed,
        row.averageCpConsumption,
        row.totalTimeLoss,
        row.totalTimeGain,
        row.totalFuelLoss,
        row.totalFuelGain,
        // row.average
      ];
      csvContent += values.join(',') + '\n';
    });
    csvContent += '\n';

    // Append "Average" in a separate row
    const averageRow = `Average,,,,,${data[0].average}`;
    csvContent += averageRow + '\n';

    // Trigger CSV Download
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    let fileName = `${type}_performance_report.csv`;
    if (type === 'both') {
      fileName = `Performance_report.csv`;
    }
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  formatVesselName(name: string): string {
    if (!name) return '';

    return name
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim().length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  openColumnFilterDialog(): void {
    const dialogRef = this.dialog.open(ColumnFilterPopupComponent, {
      width: '400px',
      data: { columns: JSON.parse(JSON.stringify(this.columns)) }, // deep copy
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.columns = result; // update visibility
      }
    });
  }

  private segmentColorMap: { [key: string]: string } = {
    mr2: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
    bitumen: '#7b4d75',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }

  filterClients(event: any) {
    const value = event.target.value.toLowerCase().trim();

    this.clientSuggestions = this.allClients.filter((c) =>
      c.toLowerCase().includes(value),
    );
  }

  onFocusClientInput() {
    this.clientDropdownOpen = true;
    this.clientSuggestions = [...this.allClients];
  }

  onBlurClientInput() {
    setTimeout(() => {
      this.clientDropdownOpen = false;
    }, 200);
  }

  onClientCheckboxChange(event: any, client: string) {
    if (event.target.checked) {
      this.selectedClients.push(client);
    } else {
      this.selectedClients = this.selectedClients.filter((c) => c !== client);
    }

    this.updateClientLabel();
  }

  updateClientLabel() {
    if (this.selectedClients.length === 0) {
      this.selectedClientLabel = '';
    } else if (this.selectedClients.length === 1) {
      this.selectedClientLabel = this.selectedClients[0];
    } else {
      this.selectedClientLabel = `${this.selectedClients.length} selected`;
    }
  }
}
interface AverageResult {
  vessel: string;
  segment: string;
  averageSpeed: number;
  averageDailyCons: number;
  averageCpConsumption: number;
  segmentAvgSpeed: number;
  consAtAvgSegSpeed: number;
  average: number;
  totalDistance: number;
  totalTimeLoss: number;
  totalTimeGain: number;
  totalFuelLoss: number;
  totalFuelGain: number;
}
